import { render, staticRenderFns } from "./TopicDetails.vue?vue&type=template&id=fc8d0d22&"
import script from "./TopicDetails.vue?vue&type=script&lang=js&"
export * from "./TopicDetails.vue?vue&type=script&lang=js&"
import style0 from "./TopicDetails.vue?vue&type=style&index=0&id=fc8d0d22&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports